<script lang="ts">
    import AccordionItem from "./AccordionItem.svelte";
    import sanityImage from "../../../sanity/sanityImage";
    import ShortUniqueId from 'short-unique-id';

    export let accordionItems : any

    //Map through items and create an functional accordion array
    let items = accordionItems.map((item) => {
        let uuid = new ShortUniqueId()
        return {
            ...item,
            id: uuid(),
            open: false
        }
    })

    const openItem  = (event : Event) => {
        items = items.map((item : any) => {
            if(item.id == event.target?.id) {
                return {
                    ...item,
                    open: !item.open
                }
            }

            return {
                ...item,
                open: false
            }
        })
    }

    //Reactive
    $ : items

</script>

<div class="accordion">
    {#each  items as item, index}
        <AccordionItem
            itemImage={
               {
                    pngUrl : item.image?.asset._ref ? sanityImage(item.image?.asset._ref) : ''
               }
            }
            itemHeading={item.heading}
            itemSubCopy={item.sub_heading}
            itemContent={item.accordion_item}
            itemID={item.id}
            open={item.open}
            on:click={openItem}
        />
    {/each}
</div>

<style lang="postcss">

</style>